import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { remap } from "./Utils";

export default class AnimationController {
  static initHeroAnim() {
    const heroEl = document.querySelector('[data-anim="hero"]');

    gsap.to('.bg', { opacity: 1, duration: 1.5 });
    heroEl && heroEl.classList.add('is-anim-over');
  }

  static initIntroAnim() {
    const introEl = document.querySelector('.page-index #intro');

    if (!introEl) return;

    ScrollTrigger.create({
      trigger: introEl,
      start: "top+=300 bottom",
      onEnter: () => introEl.classList.add('is-anim-over')
    })
  }

  static initBgAnim() {
    const heroEl = document.querySelector('.hero');
    const backgroundEl = document.querySelector('[data-anim="bg"]');

    if (!backgroundEl || !heroEl) return;

    ScrollTrigger.create({
      trigger: heroEl,
      start: "top top",
      end: "bottom top",
      scrub: true,
      onUpdate: ({ progress, getVelocity }) => {
        // const alphaProgress = (2 * progress) * (2 * (1 - progress));
        const alphaRemapped = remap(progress, 0, 1, 1, 0.3);

        gsap.to('.page-index .bg__wrap', {
          opacity: alphaRemapped,
          duration: 0.75,
          ease: "power3.out"
        })
      }
    })
  }

  static initHeadingAnim() {
    const headingEls = document.querySelectorAll('.heading');

    headingEls.forEach(el => {
      ScrollTrigger.create({
        trigger: el,
        start: "bottom 99%",
        // start: "top bottom",
        onEnter: () => el.classList.add('is-anim-over')
      })
    })
  }

  static initInnerAnim() {
    const innerEls = document.querySelectorAll('[data-anim="inner"]');

    innerEls.forEach(el => {
      ScrollTrigger.create({
        trigger: el,
        start: "top bottom",
        onEnter: () => {
          gsap.to(el, {
            y: 0,
            ease: "back.out(1.75)",
            duration: 0.85,
          })
          gsap.to(el, {
            scale: 1,
            duration: 0.85,
            ease: "expo.out"
          })
        }
      })
    })
  }


  static initArchiveAnim() {
    const archiveEl = document.querySelector('[data-anim="archive"]');

    if (!archiveEl) return;

    ScrollTrigger.create({
      trigger: archiveEl,
      start: "top+=300 bottom",
      onEnter: () => {
        archiveEl.classList.add('is-anim-over');
      }
    })
  }

  static initApplyBtnAnim() {
    const applyBtn = document.querySelector('.apply-btn');
    const productPickupEl = document.querySelector('#product-pickup');
    const productEl = document.querySelector('#products');

    ScrollTrigger.create({
      trigger: '.hero',
      start: 'top bottom',
      end: 'bottom top',
      onEnterBack: () => {
        gsap.to(applyBtn, {
          opacity: 0,
          duration: 0.3,
          onComplete: () => { applyBtn.style.visibility = 'hidden' }
        })
      },
      onLeave: () => {
        gsap.to(applyBtn, {
          opacity: 1,
          visibility: 'visible',
          duration: 0.5,
          onStart: () => { applyBtn.style.visibility = 'visible' }
        })
      }
    });

    if (productEl || productPickupEl) {
      let timer;

      function handleEnter() {
        applyBtn.classList.remove('is-attention');
        applyBtn.classList.add('is-attention');
        setTimeout(() => {
          applyBtn.classList.remove('is-attention');
        }, 500);
      }

      ScrollTrigger.create({
        trigger: productEl || productPickupEl,
        start: "top top",
        end: "bottom top",
        onEnter: () => {
          handleEnter();
          timer = setInterval(handleEnter, 15000);
        },
        onLeaveBack: () => {
          clearInterval(timer);
          applyBtn.classList.remove('is-attention');
        }
      })
    }
  }

  static initHeaderAnim() {
    const headerEl = document.querySelector('[data-header="products"]');

    if (headerEl) {
      ScrollTrigger.create({
        trigger: '.hero',
        start: 'top bottom',
        end: 'bottom top',
        onEnterBack: () => {
          gsap.to(headerEl, {
            duration: 0.01,
            onComplete: () => {
              headerEl.classList.remove('is-reverse');
            }
          })
        },
        onLeave: () => {
          gsap.to(headerEl, {
            duration: 0.01,
            onStart: () => {
              headerEl.classList.add('is-reverse');
            }
          })
        }
      });
    }

  }

  static initAll() {
    this.initBgAnim();
    this.initHeroAnim();
    this.initIntroAnim();
    this.initInnerAnim();
    this.initHeadingAnim();
    this.initArchiveAnim();
    this.initApplyBtnAnim();
    this.initHeaderAnim();
  }
}